import { useState } from "react";

export default function VariantBulkActionBar({
  selectedCount,
  totalIssues,
  issueCounts,
  onViewIssues,
  onApplyPatch,
  onApplyStatus,
}) {
  const [price, setPrice] = useState("");

  const hasSelection = selectedCount > 0;

  const applyChanges = () => {
    if (!hasSelection) return;

    const patch = {};
    if (price !== "") {
      const nextPrice = Number(price);
      if (Number.isFinite(nextPrice) && nextPrice >= 0) {
        patch.price = String(nextPrice);
      }
    }

    if (Object.keys(patch).length === 0) return;
    onApplyPatch(patch);
    setPrice("");
  };

  const missingSku = issueCounts.missingSku || 0;
  const invalidPrice = issueCounts.invalidPrice || 0;
  const inactive = issueCounts.inactive || 0;

  return (
    <div className="sticky top-2 z-20 rounded-xl border border-zinc-200 bg-white/95 px-3 py-2.5 shadow-md backdrop-blur dark:border-zinc-800 dark:bg-[#121214]/95">
      <div className="flex flex-col gap-2 xl:flex-row xl:items-center xl:justify-between">
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className="rounded-full border border-zinc-300 bg-zinc-50 px-2.5 py-1 text-xs font-semibold text-zinc-700 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-200">
            {selectedCount} selected
          </span>

          {totalIssues > 0 && (
            <button
              type="button"
              onClick={onViewIssues}
              className="inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-800 hover:bg-amber-100
                         dark:border-amber-900/40 dark:bg-amber-950/40 dark:text-amber-200 dark:hover:bg-amber-900/60"
            >
              {totalIssues} issues
            </button>
          )}

          {totalIssues > 0 && (
            <div className="flex flex-wrap items-center gap-1 text-[11px] text-zinc-500 dark:text-zinc-400">
              <span>SKU: {missingSku}</span>
              <span>Price: {invalidPrice}</span>
              <span>Inactive: {inactive}</span>
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <input
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            inputMode="decimal"
            placeholder="Set Price"
            disabled={!hasSelection}
            className="w-28 rounded-xl border border-zinc-200 px-3 py-2 text-sm disabled:opacity-50 dark:border-zinc-800 dark:bg-[#0f0f10]"
          />

          <button
            type="button"
            disabled={!hasSelection}
            onClick={() => onApplyStatus(true)}
            className="rounded-xl border border-zinc-200 px-3 py-2 text-xs font-medium text-zinc-600 hover:bg-zinc-50 disabled:opacity-50
                       dark:border-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800/60"
          >
            Activate
          </button>

          <button
            type="button"
            disabled={!hasSelection}
            onClick={() => onApplyStatus(false)}
            className="rounded-xl border border-zinc-200 px-3 py-2 text-xs font-medium text-zinc-600 hover:bg-zinc-50 disabled:opacity-50
                       dark:border-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800/60"
          >
            Deactivate
          </button>

          <button
            type="button"
            disabled={!hasSelection}
            onClick={applyChanges}
            className="rounded-xl bg-zinc-900 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 dark:bg-zinc-100 dark:text-zinc-900"
          >
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  );
}
